// This function wraps string properties in %...% for SQL LIKE queries
export function toSqlLikeString(value?: string) {
  return value ? `%${value}%` : '%';
}

export function validateJSONString(value: string): boolean {
  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
}

export function ensureNItems<T>(arr: T[], count: number): (T | undefined)[] {
  const result: (T | undefined)[] = new Array(count).fill(undefined);
  for (let i = 0; i < count && i < arr.length; i++) {
    result[i] = arr[i];
  }
  return result;
}
